'use client';

import { ComponentProps, FC } from 'react';

import { processPriceString } from 'src/general/helpers/processProductApiData';
import { FinanceDescriptionContent } from 'src/hygiene/sections/flexible-content/FinanceDescriptionContent/FinanceDescriptionContent';
import { FlexibleSection } from 'src/hygiene/sections/flexible-content/flexibleContent.type';
import { FinancePdpCalculator } from 'src/pdp/components/FinancePdpCalculator/FinancePdpCalculator';
import { ProductDetailsPayload } from 'src/types/ProductDetail.type';

interface PdpFinanceSectionProps extends FlexibleSection {
  sectionData: ComponentProps<typeof FinanceDescriptionContent>['sectionData'] & {
    note: string;
    termOfLoan: {
      min: number;
      max: number;
    };
    interestRateRange: {
      min: number;
      max: number;
    };
    buttonLabel: string;
  };
  productDetails: ProductDetailsPayload;
}

export const PdpFinanceSection: FC<PdpFinanceSectionProps> = ({ sectionData, productDetails }) => {
  return (
    <section className="c-se--default c-se--sand">
      <div className="flex flex-col gap-5 py-10 md:grid md:grid-cols-2">
        <FinanceDescriptionContent sectionData={sectionData} />
        <div>
          <div className="mb-4 rounded-lg border border-bor-neu-mut shadow-elevation-0dp">
            <FinancePdpCalculator
              interestRateRange={{
                minRate: sectionData.interestRateRange.min,
                maxRate: sectionData.interestRateRange.max,
              }}
              loanTerms={sectionData.termOfLoan}
              productPrice={processPriceString(productDetails.price)}
            />
          </div>
          <div>
            <p className="text-center text-xs text-tex-def-tie3">{sectionData.note}</p>
          </div>
        </div>
      </div>
    </section>
  );
};
